(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-predictive"] && !Shopify.designMode) return;
  try {
    (function () {
    var configEl = document.getElementById('predictive-search-config');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var roots = document.querySelectorAll('[data-predictive-search]');
    if (!roots.length) return;

    var fetchOptions = {
      credentials: 'same-origin',
      cache: 'no-store'
    };

    function hidePanel(root) {
      var panel = root.querySelector('[data-predictive-search-panel]');
      var input = root.querySelector('input[name="q"]');
      if (!panel) return;
      panel.hidden = true;
      if (input) {
        input.setAttribute('aria-expanded', 'false');
      }
    }

    function showPanel(root) {
      var panel = root.querySelector('[data-predictive-search-panel]');
      var input = root.querySelector('input[name="q"]');
      if (!panel) return;
      panel.hidden = false;
      if (input) {
        input.setAttribute('aria-expanded', 'true');
        input.setAttribute('aria-autocomplete', 'list');
      }
    }

    function appendSearchParams(params) {
      params.set('resources[type]', config.resourceTypes);
      params.set('resources[limit]', String(config.limit));
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', config.searchFields);
    }

    function buildJsonUrl(query) {
      var params = new URLSearchParams();
      params.set('q', query);
      appendSearchParams(params);
      return config.endpoint + '.json?' + params.toString();
    }

    function buildSectionUrl(query) {
      var params = new URLSearchParams();
      params.set('q', query);
      params.set('section_id', config.sectionId);
      appendSearchParams(params);
      return config.endpoint + '?' + params.toString();
    }

    function formatViewAll(label, term) {
      return label.replace('{{ terms }}', term);
    }

    function formatPrice(price) {
      if (price == null || price === '') return '';
      if (typeof price === 'string' && /[^\d.,]/.test(price)) return price;
      var amount = Number(price);
      if (isNaN(amount)) return '';
      if (amount <= 0) return 'Sur devis';
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(Math.round(amount * 100));
      }
      return amount.toFixed(2).replace('.', ',') + ' €';
    }

    function buildItem(item, type) {
      var link = document.createElement('a');
      link.href = item.url || '#';
      link.className = 'predictive-search__item';
      if (type === 'query') link.classList.add('predictive-search__item--query');
      link.setAttribute('role', 'option');

      if (type !== 'query') {
        var thumb = document.createElement('div');
        thumb.className = 'predictive-search__item-thumb';
        var imageUrl = '';

        if (type === 'product') {
          if (item.featured_image && item.featured_image.url) imageUrl = item.featured_image.url;
          else if (item.image) imageUrl = item.image;
        } else if (type === 'collection' && item.featured_image && item.featured_image.url) {
          imageUrl = item.featured_image.url;
        } else if (type === 'article' && item.image) {
          imageUrl = item.image;
        }

        if (imageUrl) {
          var img = document.createElement('img');
          img.src = imageUrl;
          img.alt = '';
          img.width = 44;
          img.height = 44;
          img.loading = 'lazy';
          thumb.appendChild(img);
        } else {
          thumb.classList.add('predictive-search__item-thumb--text');
          thumb.textContent = type === 'collection' ? 'Col.' : type === 'article' ? 'Art.' : 'Pr.';
        }
        link.appendChild(thumb);
      }

      var body = document.createElement('div');
      body.className = 'predictive-search__item-body';

      var title = document.createElement('span');
      title.className = 'predictive-search__item-title';
      if (type === 'query' && item.styled_text) {
        title.innerHTML = item.styled_text;
      } else {
        title.textContent = item.title || item.text || '';
      }
      body.appendChild(title);

      if (type === 'product' && item.price != null) {
        var meta = document.createElement('span');
        meta.className = 'predictive-search__item-meta';
        meta.textContent = formatPrice(item.price);
        body.appendChild(meta);
      }

      link.appendChild(body);
      return link;
    }

    function buildGroup(label, items, type) {
      if (!items || !items.length) return null;
      var group = document.createElement('div');
      group.className = 'predictive-search__group';
      var heading = document.createElement('p');
      heading.className = 'predictive-search__label';
      heading.textContent = label;
      group.appendChild(heading);
      items.forEach(function (item) {
        group.appendChild(buildItem(item, type));
      });
      return group;
    }

    function renderJsonResults(inner, data, query) {
      inner.innerHTML = '';
      var results = data && data.resources && data.resources.results;
      if (!results) {
        inner.innerHTML = '<p class="predictive-search__empty">' + config.labels.no_results + '</p>';
        return true;
      }

      var queries = results.queries || [];
      var products = results.products || [];
      var collections = results.collections || [];
      var pages = results.pages || [];
      var articles = results.articles || [];
      var hasAny = queries.length || products.length || collections.length || pages.length || articles.length;

      if (!hasAny) {
        inner.innerHTML = '<p class="predictive-search__empty">' + config.labels.no_results + '</p>';
        return true;
      }

      var queryGroup = buildGroup(config.labels.queries, queries, 'query');
      if (queryGroup) inner.appendChild(queryGroup);
      var productGroup = buildGroup(config.labels.products, products, 'product');
      if (productGroup) inner.appendChild(productGroup);
      var collectionGroup = buildGroup(config.labels.collections, collections, 'collection');
      if (collectionGroup) inner.appendChild(collectionGroup);
      var pageGroup = buildGroup(config.labels.pages, pages, 'page');
      if (pageGroup) inner.appendChild(pageGroup);
      var articleGroup = buildGroup(config.labels.articles, articles, 'article');
      if (articleGroup) inner.appendChild(articleGroup);

      var footer = document.createElement('a');
      footer.className = 'predictive-search__footer';
      footer.href = config.searchUrl + '?q=' + encodeURIComponent(query) + '&options[prefix]=last';
      footer.textContent = formatViewAll(config.labels.view_all, query);
      inner.appendChild(footer);
      return true;
    }

    function extractSectionHtml(responseText) {
      var doc = new DOMParser().parseFromString(responseText, 'text/html');
      var section = doc.getElementById('shopify-section-' + config.sectionId);
      if (!section) return '';
      return section.innerHTML.trim();
    }

    function fetchSuggestions(root, query) {
      var inner = root.querySelector('[data-predictive-search-inner]');
      if (!inner) return;

      if (root._predictiveAbort) {
        root._predictiveAbort.abort();
      }
      root._predictiveAbort = new AbortController();
      var signal = root._predictiveAbort.signal;

      inner.innerHTML = '<p class="predictive-search__loading">…</p>';
      showPanel(root);

      fetch(buildJsonUrl(query), Object.assign({}, fetchOptions, {
        signal: signal,
        headers: { Accept: 'application/json' }
      }))
        .then(function (res) {
          if (!res.ok) throw new Error('json failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          renderJsonResults(inner, data, query);
          showPanel(root);
        })
        .catch(function (jsonErr) {
          if (jsonErr && jsonErr.name === 'AbortError') return;

          return fetch(buildSectionUrl(query), Object.assign({}, fetchOptions, {
            signal: signal,
            headers: { Accept: 'text/html' }
          }))
            .then(function (res) {
              if (!res.ok) throw new Error('section failed: ' + res.status);
              return res.text();
            })
            .then(function (html) {
              var markup = extractSectionHtml(html);
              if (!markup) {
                inner.innerHTML = '<p class="predictive-search__empty">' + config.labels.no_results + '</p>';
              } else {
                inner.innerHTML = markup;
              }
              showPanel(root);
            });
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          inner.innerHTML = '<p class="predictive-search__empty">' + config.labels.no_results + '</p>';
          showPanel(root);
        });
    }

    roots.forEach(function (root) {
      var input = root.querySelector('input[name="q"]');
      var panel = root.querySelector('[data-predictive-search-panel]');
      if (!input || !panel) return;

      input.setAttribute('autocomplete', 'off');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-controls', panel.id || '');

      if (!panel.id) {
        panel.id = 'predictive-search-panel-' + Math.random().toString(36).slice(2, 9);
        input.setAttribute('aria-controls', panel.id);
      }

      var debounceTimer;

      input.addEventListener('input', function () {
        var query = input.value.trim();
        clearTimeout(debounceTimer);

        if (query.length < config.minChars) {
          hidePanel(root);
          return;
        }

        debounceTimer = window.setTimeout(function () {
          fetchSuggestions(root, query);
        }, config.debounceMs);
      });

      input.addEventListener('focus', function () {
        var query = input.value.trim();
        if (query.length >= config.minChars) {
          fetchSuggestions(root, query);
        }
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          hidePanel(root);
        }
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) {
          hidePanel(root);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
